import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Control, Errors, Form } from 'forms/rrf';
import { Col, Container, FormControl, FormGroup, FormLabel, Row } from 'react-bootstrap';
import BackLink from '../../../common/back-link/index';
import PageTitle from '../../../common/page-title/index';
import ArrowButton from '../../../common/button-arrow';
import RequiredInput from '../../../common/form/elements/required-input';
import RequiredSelect from '../../../common/form/elements/required-select';
import Select from '../../../common/form/elements/select';
import RequiredDatePicker from '../../../common/form/elements/required-datepicker';
import MultiSelect from '../../../common/form/multi-select';
import {getQrCodeCampaign, getQrCodeCampaignMeta, saveQrCodeCampaign, updateQrCodeCampaign} from '../../../../actions/qr-code-campaigns';

const model = 'deep.admin_qr_code_campaign';

const CAMPAIGN_TYPES = {
  game: 'Game',
  points: 'Points'
};

const MINI_CHAINS_OPTIONS = [
  { label: 'All Outlets', value: '0' },
  { label: 'MC Outlets', value: '1' },
  { label: 'Non-MC Outlets', value: '2' }
];

class NewQrCodeCampaign extends Component {
  constructor(props) {
    super(props);

    this.id = props.match.params.id;
    this.state = {
      readOnly: false,
      loaded: this.id === undefined
    };
  }

  componentWillMount() {
    const { dispatch } = this.props;

    dispatch(actions.reset(model));
    dispatch(getQrCodeCampaignMeta());

    if (this.isEdit()) {
      dispatch(getQrCodeCampaign(this.id)).then((response) => {
        if (response && response.data) {
          const { attributes } = response.data;

          dispatch(actions.load(model, this.deserialize(attributes)));
          this.setState({ readOnly: attributes.editable === false, loaded: true });
        }
      });
    }
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset(model));
  }

  onSubmit = (payLoad) => {
    const { dispatch } = this.props;
    const request = this.isEdit()
      ? updateQrCodeCampaign(this.id, payLoad)
      : saveQrCodeCampaign(payLoad);

    dispatch(actions.submitFields(model, request));
  };

  isEdit = () => this.id !== undefined;

  isReadOnly = () => this.state.readOnly;

  title = () => {
    if (!this.isEdit()) {
      return 'Add QR code campaign';
    }

    if (!this.state.loaded) {
      return 'QR code campaign';
    }

    return `${this.isReadOnly() ? 'View' : 'Edit'} QR code campaign`;
  };

  deserialize = attributes => ({
    campaign_unique_id: attributes['campaign-unique-id'] || '',
    campaign_type: attributes['campaign-type'] || 'game',
    mini_chains: String(attributes['mini-chains'] || 0),
    start_date: attributes['start-date'] || '',
    end_date: attributes['end-date'] || '',
    cataboom_id: attributes['cataboom-id'] || '',
    points_per_qr: attributes['points-per-qr'] || 0,
    abm_codes: (attributes['abm-codes'] || []).map(code => ({ label: code, value: code })),
    group_ids: (attributes.groups || []).map(group => ({ label: group.name, value: group.id }))
  });

  createGroupList = groups => groups.map(group => ({
    label: group.name,
    value: group.id
  }));

  createAbmCodeList = abmCodes => abmCodes.map(abmCode => ({
    label: abmCode,
    value: abmCode
  }));

  render() {
    const {
      formData, groups, abmCodes, formValid
    } = this.props;
    const { loaded } = this.state;
    const readOnly = this.isReadOnly();
    const fieldsDisabled = readOnly || !loaded;

    return (
      <Container fluid>
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/qr_code_campaigns"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>
              {this.title()}
            </PageTitle>
          </Col>
        </Row>
        <Form
          model={model}
          onSubmit={this.onSubmit}
        >
          <Row>
            <Col lg={12}>
              <Errors className="errors" model={model}/>
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <RequiredInput
                controlId="campaign_unique_id"
                label="Campaign unique ID"
                model=".campaign_unique_id"
                placeholder="Campaign unique ID"
                disabled={fieldsDisabled}
              />
            </Col>
            <Col lg={4}>
              <RequiredDatePicker
                label="Start date"
                controlId="start_date"
                model={`${model}.start_date`}
                placeholder="Select a date..."
                value={formData.start_date}
                disabled={fieldsDisabled}
              />
            </Col>
            <Col lg={4}>
              <RequiredDatePicker
                label="End date"
                controlId="end_date"
                model={`${model}.end_date`}
                placeholder="Select a date..."
                value={formData.end_date}
                disabled={fieldsDisabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <Select
                label="Mini chains"
                model={`${model}.mini_chains`}
                controlId="mini_chains"
                hasEmptyValue={false}
                values={MINI_CHAINS_OPTIONS}
                selectedValue={String(formData.mini_chains)}
                disabled={fieldsDisabled}
              />
            </Col>
            <Col lg={4}>
              <MultiSelect
                model={`${model}.abm_codes`}
                data={this.createAbmCodeList(abmCodes)}
                label="ABM code"
                value={formData.abm_codes || []}
                controlId="abm_codes"
                placeholder="Select..."
                disabled={fieldsDisabled}
              />
            </Col>
            <Col lg={4}>
              <MultiSelect
                model={`${model}.group_ids`}
                data={this.createGroupList(groups)}
                label="Outlet groups"
                value={formData.group_ids}
                controlId="group_ids"
                disabled={fieldsDisabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <RequiredSelect
                controlId="campaign_type"
                label="Campaign type"
                model=".campaign_type"
                values={CAMPAIGN_TYPES}
                hasEmptyValue={false}
                selectedValue={formData.campaign_type}
                disabled={fieldsDisabled}
              />
            </Col>
            <Col lg={6}>
              {formData.campaign_type === 'game' && (
                <FormGroup controlId="cataboom_id">
                  <FormLabel>
                    Cataboom ID
                  </FormLabel>
                  <Control.text
                    component={FormControl}
                    model=".cataboom_id"
                    placeholder="Cataboom ID"
                    disabled={fieldsDisabled}
                  />
                </FormGroup>
              )}
              {formData.campaign_type === 'points' && (
                <FormGroup controlId="points_per_qr">
                  <FormLabel>
                    Points per QR
                  </FormLabel>
                  <Control.text
                    component={FormControl}
                    model=".points_per_qr"
                    type="number"
                    placeholder="Points per QR"
                    disabled={fieldsDisabled}
                  />
                </FormGroup>
              )}
            </Col>
          </Row>
          {loaded && !readOnly && (
            <Row>
              <Col lg={12}>
                <ArrowButton
                  arrow={false}
                  className="pull-right"
                  color="red"
                  disabled={!formValid}
                >
                  Save
                </ArrowButton>
              </Col>
            </Row>
          )}
        </Form>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  formData: state.deep.admin_qr_code_campaign,
  groups: state.qrCodeCampaigns.groups || [],
  abmCodes: state.qrCodeCampaigns.abmCodes || [],
  formValid: state.deep.forms.admin_qr_code_campaign.$form.valid
});

export default connect(mapStateToProps)(NewQrCodeCampaign);
